import { ActivatedRoute } from '@angular/router';
import { RequestService, TissueCollectionType } from '../../shared/services/request.service';
import { Observable } from 'rxjs';
import { UserService } from '../../shared/services/user.service';
import { asEnumerable } from 'linq-es2015';
import { PlantCareTemplateService } from '../../shared/services/plant-care-template.service';
import { FacilityTypeService } from '../../shared/services/facility-type.service';
import { RequestCommentsService } from '../../shared/services/request-comments.service';
import { FacilityNameService } from '../../shared/services/facility-name.service';
import { PlanningService } from '../../shared/services/planning.service';
import { LaboratoryService } from '../../shared/services/laboratory.service';
import { GrowthStageService } from '../../shared/services/growth-stage.service';
import { TissueTypeService } from '../../shared/services/tissue-type.service';
import { SettingsService } from 'research.web.settings';
import { RequestTypeService } from '../../shared/services/request-type.service';
var ReviewRequestPageComponent = /** @class */ (function () {
    function ReviewRequestPageComponent(activatedRoute, requestService, userService, plantCareTemplateService, facilityTypeService, facilityNameService, requestCommentService, planningService, labService, growthStageService, tissueTypeService, settingsService, requestTypeService) {
        this.activatedRoute = activatedRoute;
        this.requestService = requestService;
        this.userService = userService;
        this.plantCareTemplateService = plantCareTemplateService;
        this.facilityTypeService = facilityTypeService;
        this.facilityNameService = facilityNameService;
        this.requestCommentService = requestCommentService;
        this.planningService = planningService;
        this.labService = labService;
        this.growthStageService = growthStageService;
        this.tissueTypeService = tissueTypeService;
        this.settingsService = settingsService;
        this.requestTypeService = requestTypeService;
        this.settings = this.settingsService.get("_appSettings");
    }
    Object.defineProperty(ReviewRequestPageComponent.prototype, "isWheatRequest", {
        get: function () {
            return this.request.cropId === this.settings.wheatCropId;
        },
        enumerable: true,
        configurable: true
    });
    ReviewRequestPageComponent.prototype.ngOnInit = function () {
        this.id = this.activatedRoute.snapshot.params.id;
        this.request = this.activatedRoute.snapshot.data.request;
        this.barcodeImage = this.activatedRoute.snapshot.data.requestBarcode;
        this.fetchCeLogistics();
        this.fetchRequestComments();
    };
    ReviewRequestPageComponent.prototype.refreshView = function (event) {
        this.fetchRequest();
        this.fetchRequestStatus();
        this.fetchCeLogistics();
        this.fetchRequestComments();
    };
    ReviewRequestPageComponent.prototype.fetchRequest = function () {
        var _this = this;
        this.requestService
            .getDesign(this.request.id)
            .subscribe(function (r) {
            _this.request.seedRequestDesired = r.seedRequestDesired;
        });
    };
    ReviewRequestPageComponent.prototype.fetchRequestStatus = function () {
        var _this = this;
        this.requestService
            .getRequestInformation(this.request.id)
            .subscribe(function (s) {
            _this.request.requestNumber = s.requestNumber;
            _this.request.statusId = s.statusId;
        });
    };
    ;
    ReviewRequestPageComponent.prototype.fetchCeLogistics = function () {
        var _this = this;
        Observable.forkJoin(this.requestService.getCeLogistics(this.id), this.planningService.getPlanningNotes(this.id), this.userService.getAll(), this.plantCareTemplateService.allPlantCareTemplates(), this.facilityTypeService.getAll(), this.facilityNameService.getAll(), this.labService.getAll(), this.growthStageService.getAll(), this.tissueTypeService.getAll(), this.requestTypeService.getAll()).map(function (_a) {
            var ceLogistics = _a[0], notes = _a[1], users = _a[2], pcts = _a[3], facilityTypes = _a[4], facilityNames = _a[5], labs = _a[6], growthStages = _a[7], tissueTypes = _a[8], requestTypes = _a[9];
            var planningNotes = notes || {};
            var tl = ceLogistics.tacticalLiaisonId ? asEnumerable(users).Single(function (u) { return u.id === ceLogistics.tacticalLiaisonId; }) : null;
            var pct = planningNotes.plantCareTemplateId ? asEnumerable(pcts).Single(function (t) { return t.id === planningNotes.plantCareTemplateId; }) : null;
            var aoi = ceLogistics.aoiName;
            var requestType = ceLogistics.requestTypeId ? asEnumerable(requestTypes).Single(function (u) { return u.id === ceLogistics.requestTypeId; }) : null;
            _this.config = {
                facilityTypes: asEnumerable(facilityTypes),
                facilityNames: asEnumerable(facilityNames),
                laboratories: asEnumerable(labs),
                growthStages: asEnumerable(growthStages),
                tissueTypes: asEnumerable(tissueTypes)
            };
            var samplings = null;
            if (planningNotes.samplingNeeds) {
                samplings = [];
                planningNotes.samplingNeeds.forEach(function (s) {
                    var laboratory = s.laboratoryId ? _this.config.laboratories.SingleOrDefault(function (l) { return l.id === s.laboratoryId; }) : null;
                    var labName = laboratory ? laboratory.name : null;
                    var assay = s.laboratoryAssayId ? asEnumerable(laboratory.assays).Single(function (l) { return l.id === s.laboratoryAssayId; }).name : null;
                    var tissueType = s.tissueTypeId ? _this.config.tissueTypes.SingleOrDefault(function (l) { return l.id === s.tissueTypeId; }).name : null;
                    var tissueCollectionType = TissueCollectionType[s.tissueCollectionType];
                    var growthStage = s.growthStageId !== null ? _this.config.growthStages.SingleOrDefault(function (l) { return l.id === s.growthStageId; }).name : null;
                    samplings.push({
                        assay: assay,
                        laboratory: labName,
                        tissueType: tissueType,
                        order: s.order,
                        tissueCollectionType: tissueCollectionType,
                        growthStage: growthStage,
                        daysAfterPlanting: s.daysAfterPlanting,
                        notes: s.notes
                    });
                });
            }
            _this.ceLogistics = {
                requestId: ceLogistics.requestId,
                tacticalLiaison: tl ? tl.givenName + " " + tl.surname : null,
                tagsOnly: planningNotes.tagsOnly,
                insectsAllowed: planningNotes.insectsAllowed != null ? planningNotes.insectsAllowed : true,
                specificAoiRequired: planningNotes.specificAoiRequired,
                plannedAoiLocation: planningNotes.plannedAoiLocation,
                plantCareTemplate: pct ? pct.name : "Not Applicable",
                notes: planningNotes.notes,
                requestType: requestType ? requestType.name : null,
                plannedPlantingDate: planningNotes.plannedPlantingDate,
                facilityType: ceLogistics.facilityId ? _this.config.facilityTypes.Single(function (t) { return t.id === ceLogistics.facilityId; }).name : null,
                prismExperimentName: ceLogistics.prismExperimentName,
                aoi: aoi,
                actualPlantDate: ceLogistics.actualPlantDate,
                requestedSamplings: samplings,
                treatmentDetails: planningNotes.treatmentDetails ?
                    asEnumerable(planningNotes.treatmentDetails)
                        .Select(function (d) { return ({
                        treatmentNumber: d.treatmentNumber,
                        flatStorageFacilityType: d.flatStorageFacilityTypeId ? _this.config.facilityTypes.Single(function (t) { return t.id === d.flatStorageFacilityTypeId; }).name : null,
                        flatStorageFacilityLocation: d.flatStorageFacilityLocationId ? _this.config.facilityNames.Single(function (n) { return n.id === d.flatStorageFacilityLocationId; }).name : null,
                        automationPotStorageFacilityType: d.automationPotStorageFacilityTypeId ? _this.config.facilityTypes.Single(function (t) { return t.id === d.automationPotStorageFacilityTypeId; }).name : null,
                        automationPotStorageLocation: d.automationPotStorageLocationId ? _this.config.facilityNames.Single(function (n) { return n.id === d.automationPotStorageLocationId; }).name : null,
                        staticPotStorageFacilityType: d.staticPotStorageFacilityTypeId ? _this.config.facilityTypes.Single(function (t) { return t.id === d.staticPotStorageFacilityTypeId; }).name : null,
                        staticPotStorageLocation: d.staticPotStorageLocationId ? _this.config.facilityNames.Single(function (n) { return n.id === d.staticPotStorageLocationId; }).name : null,
                        comments: d.comments ? asEnumerable(d.comments)
                            .Select(function (c) { return ({
                            instructionType: c.instructionType,
                            instructionSubtype: c.instructionSubtype,
                            comment: c.comment
                        }); })
                            .OrderBy(function (c) { return c.instructionType; })
                            .ThenBy(function (c) { return c.instructionSubtype; })
                            .ToArray() : null
                    }); })
                        .ToArray() : null,
            };
        }).subscribe();
    };
    ReviewRequestPageComponent.prototype.fetchRequestComments = function () {
        var _this = this;
        Observable.forkJoin(this.requestCommentService.getAll(this.id), this.userService.getAll()).map(function (_a) {
            var comments = _a[0], users = _a[1];
            var requestComments = [];
            var _loop_1 = function (requestComment) {
                var user = asEnumerable(users).Single(function (u) { return u.id === requestComment.createdBy; });
                requestComments.push({
                    createdOn: requestComment.createdOn,
                    createdBy: user.givenName + " " + user.surname,
                    comment: requestComment.comment,
                    source: requestComment.source
                });
            };
            for (var _i = 0, comments_1 = comments; _i < comments_1.length; _i++) {
                var requestComment = comments_1[_i];
                _loop_1(requestComment);
            }
            return requestComments;
        }).subscribe(function (requestComments) { return _this.requestComments = requestComments; });
    };
    return ReviewRequestPageComponent;
}());
export { ReviewRequestPageComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/review-request-page/review-request-page.component.ts.pre-build-optimizer.js